import React from "react";

const PriceSectionCardSkeleton = () => {
  return (
    <div className= "PriceSectionCardSkeleton-wrapper">
      <div className="modern-pricing-card">
        {/* Title */}
        <div className="text-center mb-2">
          <div className="skeleton skeleton-title mx-auto mb-4"></div>
          <div>
            <div className="skeleton skeleton-subtitle mx-auto"></div>
            <div className="skeleton skeleton-save-text" style={{margin: 'auto'}}></div>
          </div>
        </div>

        {/* Price */}
        <div
          className="modern-plan-price text-center d-flex flex-column justify-content-center align-items-center mb-2"
          style={{ minHeight: "100px" }}
        >
          <div className="d-flex justify-content-center align-items-center mb-2">
            <div className="skeleton skeleton-strike me-2"></div>
            <div className="skeleton skeleton-price"></div>
          </div>

          <div className="skeleton skeleton-save-text"></div>
        </div>

        {/* Button */}
        <div className="d-flex justify-content-center mb-4 w-100">
          <div className="skeleton skeleton-button"></div>
        </div>

        {/* Lines */}
        <div className="text-center mb-3 mt-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="skeleton skeleton-line mb-4"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PriceSectionCardSkeleton;
